<template>
  <div>
    <!-- Root element -->
    <div class="logos-container no-underline inline-flex">
      <template v-for="(logo, index) in logos">
        <a class="logo-wrapper" :class="{ 'mobile-hidden': logo.hideOnMobile }" :href="getLogoHref(logo)" :tabindex="index" @click="handleLogoClick($event, logo)" @keydown.enter.space="handleLogoClick($event, logo)" :key="index">
          <img :class="{ 'aspect-ratio-1': logo.squareOnMobile }" :src="getLogoPath(logo)" :width="logo.width" :height="logo.height" :alt="$t(defaultTitle)" class="logoimg">
        </a>
        <div v-if="showDividers && index < logos.length - 1 && !logo.hideOnMobile" class="brdr-logo-divider my20 brdr-cl-accent brdr-right-1" :key="`divider-${index.toString}`" />
      </template>
    </div>
    <no-ssr>
      <component
        :is="modalComponent"
        v-if="modalComponent"
        :visible="isPartnerModalVisible"
        :redirect-link="modalRedirectLink"
        @closeModal="isPartnerModalVisible = false"
      />
    </no-ssr>
  </div>
</template>

<script>
import config from 'config'
import NoSSR from 'vue-no-ssr'
import { mapState } from 'vuex'
import { toQueryString } from '@vue-storefront/core/lib/multistore'
import PartnerModalSbcr from '../theme/sbcr/PartnerModalSbcr.vue';
import PartnerModalHighlandSport from '../theme/highlandsport/PartnerModalHighlandSport.vue';

const headerModalComponents = {
  sbcr: PartnerModalSbcr,
  highlandsport: PartnerModalHighlandSport
};

export default {
  data () {
    return {
      windowWidth: 0,
      isPartnerModalVisible: false
    }
  },
  props: {
    logos: {
      type: Array,
      required: true,
      default: () => [{
        path: '/assets/anylogo.svg',
        pathResp: '/assets/anylogo.svg',
        width: 'auto',
        height: '66px'
      }]
    },
    showDividers: {
      type: Boolean,
      default: false
    },
    modal: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      storeView: state => state.storeView
    }),
    defaultTitle () {
      return this.storeView?.seo?.defaultTitle || config.seo.defaultTitle;
    },
    modalComponent () {
      return headerModalComponents[this.modal];
    },
    modalRedirectLink () {
      const modalLogo = this.logos.find(logo => logo.opensModal);
      return modalLogo ? this.getLogoLink(modalLogo) : '';
    }
  },
  methods: {
    handleLogoClick (event, logo) {
      if (logo.opensModal && this.modalComponent) {
        event.preventDefault();
        this.isPartnerModalVisible = true;
      }
    },
    getLogoHref (logo) {
      return logo.opensModal && this.modalComponent ? null : this.getLogoLink(logo);
    },
    getLogoLink (logo) {
      if (logo?.link) {
        return logo.link
      } else {
        const queryString = toQueryString(this.$route.query) || '';
        return `/?${queryString}`
      }
    },
    getLogoPath (logo) {
      return this.windowWidth < 575 ? logo.pathResp : logo.path;
    },
    handleResize () {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted () {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
  },
  components: {
    'no-ssr': NoSSR
  }
}
</script>
<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';

  $color-partner: color(partner);

  .logos-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    @media (max-width: 767px) {
      gap: 0.5rem;
    }
    @media (max-width: 350px) {
      gap: 0;
    }
    .brdr-logo-divider {
      align-self: stretch;
    }
  }
  .logo-wrapper {
    cursor: pointer;
    margin-block: 15px;
    padding-inline: 5px;
    display: flex;
    align-items: center;
    &:first-of-type {
      padding-left: 0;
    }
    &:last-of-type {
      padding-right: 0;
    }
    @media only screen and (max-width: 767px) {
      padding-inline: 4px;
    }
  }

  .brdr-cl-accent {
    border-color: $color-partner;
  }
  .logoimg {
    @media only screen and (max-width: 575px) {
      height:38px;
    }
    @media only screen and (min-width: 576px) and (max-width: 767px) {
      height:48px;
    }
  }
  .aspect-ratio-1 {
    @media only screen and (max-width: 500px) {
      aspect-ratio: 1;
    }
  }
  @media (max-width: 767px) {
  .mobile-hidden {
    display: none !important;
  }
}
</style>
